
window.getCookie = function(name) {
    const match = document.cookie.match(new RegExp(name + '=([^;]+)'));
    if (match) return match[1];
  }
  
function doOnce() { 
  const firstVisitKey = 'riversol_first_visit';

  if (!(localStorage.getItem(firstVisitKey) || getCookie(firstVisitKey))) {
    console.log("It's your first visit - Welcome!");
    // Keep existing behavior: escape '&' so it doesn't break stored value.
    const url = window.location.href.replace(/&/g, "%26");
    localStorage.setItem(firstVisitKey, url);
    document.cookie =
      firstVisitKey + '=' + url + '; expires=Fri, 31 Dec 9999 23:59:59 GMT';
  }

  const landingUrlKey = 'riversol_landing_url';
  if (!sessionStorage.getItem(landingUrlKey)) {
    const url_l = encodeURIComponent(window.location.href);
    sessionStorage.setItem(landingUrlKey, url_l);
  }

  const referringUrlKey = 'riversol_referring_url';
  if (!sessionStorage.getItem(referringUrlKey)) {
    const url_r = encodeURIComponent(document.referrer);
    sessionStorage.setItem(referringUrlKey, url_r);
  }
}
doOnce();